/*
 * Test de síntomas Neopausia (sección de Shopify).
 * Se monta en cada elemento [data-nts] y lee su configuración de [data-nts-config].
 * Textos: OWNER_COPY viene de resultado.neopausia.com y del Typeform; DRAFT_COPY son borradores por aprobar.
 * Puntaje: misma regla que resultado.neopausia.com (ver docs/resultado-actual.md).
 */
(function () {
  'use strict';

  var ASSETS = 'https://resultado.neopausia.com/assets/';
  var SCALE = ['No siento molestia', 'Molestia leve', 'Molestia moderada', 'Molestia importante', 'Demasiada molestia'];
  var TRACKING_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'lead_stage'];

  // ---------------------------------------------------------------------------
  // Contrato de POST /public/symptom-tests (core-service): claves y etiquetas del core.
  // El servidor guarda cualquier texto que llegue; si una etiqueta no coincide con la de Typeform
  // se rompen los segments y el contenido dinámico de los correos de Klaviyo. No se envían puntajes: el servidor los recalcula.
  // ---------------------------------------------------------------------------
  var SYMPTOM_FIELDS = {
    bochornos: 'somaticHotFlashes',
    corazon: 'somaticHeartPalpitations',
    articulaciones: 'somaticMuscularJointPain',
    sueno: 'somaticSleepProblems',
    animo: 'psychologicDepression',
    irritabilidad: 'psychologicIrritability',
    ansiedad: 'psychologicAnxiety',
    cansancio: 'psychologicPhysicalAndMentalFatigue',
    sexual: 'urogenitalSexualProblems',
    orina: 'urogenitalUrinaryProblems',
    sequedad: 'urogenitalVaginalDryness',
    peso: 'corporalChangesWeightGain',
    ciclo: 'corporalChangesIrregularMenstrualCycle'
  };
  var CORE_LABELS = {
    // "entender" se guarda con la etiqueta de Typeform "Obtener más conocimiento…": cambia el significado de la opción
    // para los correos de Klaviyo. Pendiente de confirmar con Nathi; si cambia, se cambia solo acá.
    busca: {
      medica: 'Atenderte con una ginecóloga especializada en menopausia',
      psicologa: 'Creo que necesito apoyo de una psicóloga dedicada al tema',
      nutricion: 'Recibir ayuda y guía en tu nutrición y estilo de vida',
      entender: 'Obtener más conocimiento, p.ej. hacer un curso o atender una charla informativa'
    },
    prevision: {
      privada: 'Salud privada (Clínicas / consultas privadas / centros de salud (Redsalud, Integramédica, Policenter, etc))',
      publica: 'Salud pública (CESFAM, SAPU, Consultorio, Hospital)'
    },
    orientacion: {
      no_segura: 'No estoy segura de que necesite ayuda profesional',
      conocer_mas: 'Sí, pero me gustaría conocer más sobre las opciones antes de tomar una decisión',
      lista: 'Sí, estoy lista para agendar una consulta'
    }
  };

  function pad2(n) { n = Number(n); return (n < 10 ? '0' : '') + n; }

  // UUID v4. Se genera una vez por envío: el reintento manda el mismo, así el servidor no crea otro test.
  function newSubmissionId() {
    var c = window.crypto;
    if (c && c.randomUUID) return c.randomUUID();
    var b = new Uint8Array(16);
    if (c && c.getRandomValues) c.getRandomValues(b);
    else for (var i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256);
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    var h = Array.prototype.map.call(b, function (x) { return (x < 16 ? '0' : '') + x.toString(16); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }

  // ---------------------------------------------------------------------------
  // Textos de Neopausia (Typeform y resultado.neopausia.com), copiados tal cual.
  // ---------------------------------------------------------------------------
  var OWNER_COPY = {
    nameQuestion: '¿Cómo te llamas?',
    total: [
      { max: 7, label: 'Impacto leve en tu calidad de vida', paragraph: 'Tu puntaje muestra un impacto leve por ahora. Pero ojo — el test no mide los efectos invisibles de esta etapa: la salud de tus huesos, tu corazón, tu metabolismo. Informarte hoy y seguir observando cómo evolucionas es la mejor forma de estar un paso adelante.' },
      { max: 14, label: 'Impacto moderado en tu calidad de vida', paragraph: 'Tu puntaje muestra que los síntomas ya están afectando tu calidad de vida. No tienes que esperar a sentirte peor para buscar apoyo — este es el momento ideal para actuar antes de que los cambios avancen más.' },
      { max: 44, label: 'Impacto importante en tu calidad de vida', paragraph: 'Tu cuerpo te está hablando fuerte. Este puntaje nos dice que ya es momento de actuar — no de esperar ni aguantar. Hay soluciones reales, y una de nuestras especialistas puede ayudarte a encontrar la tuya.' }
    ],
    resultTitle: 'aquí está tu resultado.',
    mrsNote: 'El test que completaste es el <strong>Menopause Rating Scale (MRS)</strong>, una escala usada a nivel mundial por especialistas en menopausia.',
    areasTitle: '¿Dónde te está afectando más?',
    areasSub: 'El test mide cuatro áreas. Aquí ves tu resultado en cada una.',
    toldUs: 'Lo que nos contaste',
    improveTitle: 'Así mejoran nuestras pacientes en poco tiempo',
    improveNote: 'Estudio MUSA 2026: medimos a 1.301 de nuestras pacientes antes y después de iniciar terapia hormonal.',
    // Áreas: "el síntoma" pasó a plural porque cada área agrupa varios síntomas (pedido de Nathi, 2026-10-28).
    areas: {
      somatic: {
        card: 'Síntomas Somáticos', name: 'síntomas físicos', max: 16, cuts: [3, 7], img: 'cat-somatico-C761zg91.jpg',
        desc: 'Bochornos, palpitaciones, molestias en articulaciones o músculos, insomnio.',
        paragraphs: ['Los bochornos, las palpitaciones y el insomnio parecen cosas distintas, pero tienen una raíz en común. El estrógeno regula el termostato del cerebro. Cuando baja, ese termostato se vuelve hipersensible y dispara calor donde no corresponde. Y eso no solo te afecta en el día: también te despierta en la noche, y ahí empieza el círculo: duermes mal, al otro día no rindes y todo pesa más.', 'No estás exagerando. Son los síntomas más medidos de la menopausia.'],
        improvements: [['53%', 'menos bochornos'], ['36%', 'mejor sueño'], ['40%', 'menos palpitaciones']]
      },
      psychologic: {
        card: 'Síntomas Psicológicos', name: 'síntomas psicológicos', max: 16, cuts: [2, 5], img: 'cat-psicologico-CzTIY_OX.jpg',
        desc: 'Cambios de ánimo, irritabilidad, ansiedad, depresión, neblina mental.',
        paragraphs: ['La irritabilidad, la ansiedad y la neblina mental no son carácter ni hay algo malo contigo. Hay receptores de estrógeno en el cerebro, justo en las zonas que regulan el ánimo y la memoria. Cuando el estrógeno cae, esa regulación se desordena. Por eso tantas mujeres llegan diciendo: no me reconozco.', 'No es un tema aparte de lo hormonal. Es hormonal.'],
        improvements: [['40%', 'menos ánimo depresivo y ansiedad'], ['36%', 'menos irritabilidad']]
      },
      urogenital: {
        card: 'Síntomas Urogenitales', name: 'zona íntima', max: 12, cuts: [2, 5], img: 'cat-urogenital-CeiHmMHb.jpg',
        desc: 'Sequedad vaginal, molestias al tener relaciones, infecciones urinarias, incontinencia.',
        paragraphs: ['Son los síntomas de los que menos se habla y los que más se aguantan en silencio. Los tejidos de la vagina y la uretra tienen receptores de estrógeno: cuando este baja, la zona se adelgaza, se reseca y pierde elasticidad. Por eso aparecen las molestias al tener relaciones y las infecciones urinarias a repetición.', 'Y a diferencia de los bochornos, estos síntomas no se pasan solos con el tiempo. Sin tratamiento, tienden a avanzar.'],
        improvements: [['39%', 'menos sequedad vaginal'], ['33%', 'menos molestias urinarias'], ['47%', 'menos sequedad, sumando tratamiento local']]
      },
      corporalChanges: {
        card: 'Cambios Corporales', name: 'cambios en tu cuerpo', max: 4, cuts: [1, 2], img: 'cat-corporal-BJpBhegG.jpg',
        desc: 'Cambios en el peso, aumento de grasa abdominal, sensación de hinchazón.',
        paragraphs: ['No es que hayas dejado de esforzarte, incluso quizás ya estás haciendo dietas, pero no te resultan. Cuando bajan los estrógenos, la grasa se redistribuye: deja de acumularse en caderas y se va al abdomen. Al mismo tiempo se pierde masa muscular y el metabolismo baja. Lo que antes funcionaba deja de funcionar, y eso no es falta de disciplina.'],
        boxLabel: 'Así lo trabajamos en Neopausia',
        boxData: 'Es un cambio metabólico con causa hormonal y se aborda como tal. Lo trabajamos en equipo: con médicas y nutricionistas dedicadas a la salud hormonal femenina.'
      }
    },
    stage: {
      perimenopausia: { lead: 'Basándonos en tus respuestas, lo más probable es que estés en', name: 'perimenopausia', rest: ' — la etapa de transición hacia la menopausia. Puede durar entre 4 y 10 años: los ciclos se vuelven irregulares y los síntomas aparecen mucho antes de la última menstruación.', tipTitle: '💡 No tienes que esperar tu última regla para tomar acción.', tip: 'Si ya lo estás sintiendo, ya es momento. La perimenopausia es la etapa donde intervenir temprano marca la diferencia — no hay que aguantar para merecer apoyo.' },
      postmenopausia: { lead: 'Basándonos en tus respuestas, lo más probable es que estés en', name: 'postmenopausia', rest: ' — llevas más de 12 meses sin menstruar (en promedio, la menopausia ocurre a los 51 años). En esta etapa los síntomas pueden mantenerse o aparecer nuevos cambios, depende de cada mujer.', tipTitle: '💡 Si estás pensando en terapia hormonal, el momento importa.', tip: 'La evidencia es clara: para obtener el mayor beneficio protector — en tus huesos y tu corazón — la terapia hormonal debe iniciarse dentro de los primeros 10 años desde tu última regla. Hoy puedes sentar la base para vivir la etapa más larga de tu vida con alta calidad de vida.' },
      title: '¿En qué etapa estás?',
      subtitle: 'La caída hormonal no es lineal — y eso explica la montaña rusa que sientes',
      note: '🔔 Referencia educativa simplificada · Edades aproximadas · No reemplaza diagnóstico médico',
      chartHere: 'TÚ ESTÁS AQUÍ'
    },
    projection: {
      bands: [
        { name: 'mínimo', min: 0, max: 4, withDelta: -0.4, withoutDelta: 2.8 },
        { name: 'leve', min: 5, max: 8, withDelta: 0.7, withoutDelta: 3.3 },
        { name: 'moderado', min: 9, max: 14, withDelta: -3.2, withoutDelta: 2.2 },
        { name: 'severo', min: 15, max: 44, withDelta: -9.4, withoutDelta: -0.1 }
      ],
      titleActive: 'Dónde podrías estar en unos meses',
      titleLow: '¿Y si no haces nada?',
      labels: ['Tu puntaje hoy', 'Puntaje después de unos meses en terapia con Neopausia', 'Puntaje después de unos meses sin tomar acción'],
      severo: 'Las pacientes que partieron en tu mismo rango e iniciaron terapia con Neopausia bajaron en promedio 9,4 puntos, y el 85% mejoró en algún grado. Las que no tomaron acción se mantuvieron prácticamente igual.',
      moderado: 'Las pacientes que partieron en tu mismo rango e iniciaron terapia con Neopausia bajaron en promedio 3,2 puntos, y el 68% mejoró en algún grado. Las que no tomaron acción empeoraron: aumentaron sus síntomas en 2,2 puntos.',
      activeLine: 'Sin tratamiento, los síntomas tienden a avanzar.',
      activeNote: 'Fuente: Estudio MUSA 2026. Promedio medido con el primer esquema de terapia indicado, antes del primer ajuste. No es una promesa de resultado individual.',
      low1: 'Hoy tus síntomas son leves. Pero si no tomas acción, lo más probable es que aumenten.',
      low2: function (band) { return 'Seguimos a 3.106 mujeres que no tomaron acción: en unos meses sus síntomas aumentaron en promedio ' + (band === 'mínimo' ? '2,8' : '3,3') + ' puntos.'; },
      lowLine: 'La menopausia no se detiene sola.',
      lowNote: 'Fuente: Estudio MUSA 2026.',
      whenTitle: '¿Cuándo voy a sentirme mejor?',
      when: 'Muchas mujeres notan cambios en las primeras semanas. A los 3 meses realizamos el control: tu doctora revisa cómo vas, ajusta la dosis o cambia el esquema si hace falta.',
      whenActive: ' Por eso el resultado que ves arriba es el punto de partida del proceso, no su techo.'
    },
    consult: {
      title: 'Un enfoque integral para todo lo que estás sintiendo',
      name: 'Consulta médica',
      desc: 'Junta a tu doctora especialista evalúan tus síntomas y co crean tu plan de acción para volver a tu equilibrio hormonal, p.ej. vía terapia hormonal y cambios en el estilo de vida.',
      facts: ['30 min', 'Online', 'Reembolsable con Isapre'],
      cta: 'Agendar consulta médica',
      teamImg: 'team-medico-H4bBqG8P.png',
      teamAlt: 'Equipo médico Neopausia'
    },
    socialTitle: 'Más de 10.000 mujeres ya cambiaron su menopausia',
    groupImg: 'mujeres-grupo-DJV1dR5y.png',
    stats: [
      { value: '10.000+', label: 'Mujeres atendidas' },
      { value: '79%', label: 'Mejoró sus síntomas en pocas semanas' }
    ],
    // Citas elegidas por Nathi (2026-10-28). La primera se muestra antes de pedir los datos de contacto.
    testimonials: [
      { text: 'Chicas son lo máximo. Estaba tan angustiada. Esta fue mi segunda consulta y me siento muy feliz y tranquila. O sea... ¡atómico!', name: 'Paula' },
      { text: 'La cercanía que una mujer en menopausia necesita. Pasé por varios médicos antes y hoy me quedo con la doc y el equipo de Neopausia.', name: 'Priscila' },
      { text: 'Son la luz en momentos de oscuridad... maravillosa conversación, nuevamente gran aprendizaje. No me queda más que darles las gracias por todo el apoyo. ❤️', name: 'Erika' },
      { text: 'Me ha cambiado la vida la terapia de reemplazo hormonal y no exagero con la expresión. Soy bien aplicada con las dosis, alimentación y ejercicios.', name: 'Carla' },
      { text: 'Maravilloso, estoy muy agradecida y esperanzada de poder estar apoyándome por ustedes. ¡Gracias por acompañarnos en esta etapa!', name: 'Ketty' },
      { text: 'Llevo como 3 semanas y un poco más y he tenido cero neblina mental.', name: 'Eve' },
      { text: 'Agradezco su calidez, empatía y su claridad para explicar conceptos médicos complejos.', name: 'María' },
      { text: 'La terapia hormonal me ha salvado la vida, me las recetó una doctora de Neopausia.', name: 'Vivi' }
    ],
    howTitle: 'Cómo funciona',
    how: [
      { title: 'Elige tu especialista' },
      { title: 'Agenda y paga' },
      { title: 'Recibe orden de exámenes' },
      { title: 'Tu consulta y plan' }
    ],
    faqTitle: 'Antes de agendar, lo que más nos preguntan',
    faq: [
      { q: '¿La terapia hormonal es segura?', a: ['El miedo viene de un estudio del año 2002 que estuvo mal diseñado y que además se interpretó de forma incorrecta. Hoy esa lectura está corregida.', 'La evidencia actual es clara: en mujeres sanas, sin contraindicaciones, que inician terapia hormonal dentro de los diez años desde su última regla o antes, el beneficio supera al riesgo por lejos.', 'No es para todas, pero en promedio un 90% de las mujeres puede tomarla de forma segura y efectiva. Por eso existe la consulta: tu doctora revisa tus antecedentes contigo y juntas deciden cuál es el camino correcto para ti.'] },
      { q: '¿Y si no quiero hormonas?', a: ['Está bien, y no es requisito. La consulta es una evaluación, no una receta automática.', 'Hay manejo de síntomas sin terapia hormonal: con otros fármacos y con cambios en tu estilo de vida.', 'Y si se indica terapia, siempre se ajusta en el control de los tres meses. No es una decisión de una sola vez ni un camino sin vuelta. Nuestras doctoras te acompañan para tomar la decisión que sea mejor para ti.'] },
      { q: '¿Funciona atenderse online?', a: ['Sí. En Neopausia apostamos por lo digital y ofrecemos consultas online para darte una experiencia cómoda, rápida y accesible. Nuestras pacientes aman el formato.', 'En menopausia el diagnóstico se basa en tu historia, tus síntomas y tus exámenes. Todo eso se puede evaluar perfectamente online.', 'Online no significa menos. Significa atención especializada, cercana y a tiempo, estés donde estés.'] },
      { q: '¿Mi Isapre lo cubre?', a: ['Se trata de una consulta particular, reembolsable con tu Isapre con tu boleta a mano. El monto que cubra dependerá de tu Isapre y, si tienes, de tu seguro complementario.'] },
      // Un arreglo dentro de "a" se muestra como lista.
      { q: '¿Qué exámenes necesito para la consulta?', a: ['Al reservar tu consulta con Neopausia, te enviaremos las órdenes médicas correspondientes.', 'Generalmente requerimos lo siguiente con una fecha de antigüedad no mayor a 12 meses (esto puede variar según tu historial médico específico):', ['Perfil lipídico (examen de colesterol) mediante análisis de sangre.', 'Presión arterial.', 'Mamografía', 'Ecografía mamaria.', 'Solo en caso de sangrado anormal no explicado: Ecografía transvaginal.']] }
    ],
    disclaimer: 'Esta página es una guía de orientación, no un diagnóstico. No mide riesgos invisibles como salud cardiovascular u osteoporosis, y no reemplaza la evaluación de una médica especializada.'
  };

  // ---------------------------------------------------------------------------
  // Textos nuevos: BORRADOR para revisar con Neopausia.
  // Los textos de la pantalla de entrada se editan en el editor del tema.
  // ---------------------------------------------------------------------------
  var DRAFT_COPY = {
    namePlaceholder: 'Tu nombre',
    nameError: 'Escribe tu nombre para empezar.',
    partialTag: function (n, total) { return 'Tu resultado parcial · ' + n + ' de ' + total; },
    partialTitle: function (area) { return 'Así te están afectando los ' + area; },
    partialTitleCorporal: 'Así te están afectando los cambios en tu cuerpo',
    partialTitleUro: 'Así te está afectando la zona íntima',
    lowLevel: 'Hoy esta área te afecta poco. Igual la consideramos en tu resultado final.',
    // Frase de cierre de cada grupo, en el resultado parcial y en el capítulo "Por qué te pasa".
    groupClose: {
      somatic: 'Volver a dormir de corrido y dejar de pasar calor a cada rato es posible. Te acompañamos a encontrar cómo.',
      psychologic: 'Volver a sentirte tú misma es posible, y no tienes que hacerlo sola. Aquí te escuchamos y te acompañamos.',
      urogenital: 'Hablarlo ya es un paso, y aquí puedes hacerlo con total confianza. Tiene solución y te acompañamos.',
      corporalChanges: 'Con un plan pensado para tu cuerpo en esta etapa, estos cambios se pueden trabajar. No estás sola en esto.'
    },
    // Frase del resultado parcial: nombra el grupo y valida lo que siente (textos de Nathi, 2026-10-28; corporal es borrador).
    groupLine: {
      somatic: 'Los síntomas físicos pueden afectar tu día a día profundamente.',
      psychologic: 'El bienestar emocional suele verse muy afectado por los síntomas psicológicos y especialmente en esta etapa en la que cargamos con tantas responsabilidades.',
      urogenital: 'A diferencia de los bochornos, los síntomas urogenitales no se pasan solos con el tiempo.',
      corporalChanges: 'Los cambios en tu cuerpo pueden afectar cómo te sientes contigo misma. No es falta de disciplina: cuando bajan los estrógenos, tu cuerpo cambia.'
    },
    // Resultado parcial de "Otros cambios": nombre de cada síntoma y la frase del ciclo (borrador).
    corporalItems: { peso: 'Peso y cambios en tu cuerpo', ciclo: 'Ciclo menstrual' },
    cycleLine: 'Un ciclo que cambia sin aviso desordena tu día a día. Suele ser una de las primeras señales de que tus hormonas están cambiando, y se puede acompañar.',
    psychTeam: 'Además, sumamos psicólogas a nuestro equipo, dedicadas a acompañarte en esta etapa.',
    // Mensaje cuando marca "Molestia importante" o "Demasiada molestia", uno por síntoma.
    validateHigh: {
      bochornos: 'Pasar calor de golpe, de día y de noche, agota. Gracias por contárnoslo.',
      corazon: 'Sentir el corazón acelerado asusta. Es algo que vale la pena revisar con una médica.',
      articulaciones: 'Esos dolores son reales. No es la edad, y no tienes que aguantarlos.',
      sueno: 'Dormir mal lo cambia todo. No tienes que acostumbrarte a eso.',
      animo: 'Gracias por contárnoslo. Lo que sientes tiene nombre, y no estás sola.',
      irritabilidad: 'Explotar por todo y no reconocerte cansa. No es tu carácter.',
      ansiedad: 'La angustia sin un motivo claro pesa mucho. Tiene explicación, y tiene manejo.',
      cansancio: 'La neblina mental y el cansancio no son flojera ni falta de voluntad.',
      sexual: 'Gracias por la confianza. De esto se habla poco, y tiene solución.',
      orina: 'Le pasa a muchas más mujeres de lo que se dice. No tienes que aguantarlo en silencio.',
      sequedad: 'Las molestias íntimas se pueden tratar. Aquí puedes hablarlo con confianza.',
      peso: 'No es falta de disciplina: tu cuerpo está cambiando en esta etapa.',
      ciclo: 'Los ciclos irregulares suelen ser una de las primeras señales de esta transición.'
    },
    // Se muestra fijo, sin avanzar solo, si marca molestia alta en ánimo depresivo ("sin ganas de vivir").
    moodSafety: 'Si sientes que no puedes más o has pensado en hacerte daño, no esperes: en Chile puedes llamar gratis al *4141, todos los días y a toda hora.',
    scoreHint: 'Mientras más alto el puntaje, más te están afectando los síntomas.',
    scaleLabels: ['Leve', 'Moderado', 'Importante'],
    projHint: 'Recuerda, mientras más bajo tu puntaje, mejor.',
    moreReviews: 'Ver más opiniones',
    deltaDown: function (n) { return '↓ ' + n + ' puntos menos'; },
    deltaUp: function (n) { return '↑ ' + n + ' puntos más'; },
    deltaSame: 'Casi igual',
    // Línea sobre el botón Siguiente del resultado parcial, que anuncia la próxima categoría.
    nextCategory: {
      somatic: 'Próxima categoría: síntomas psicológicos',
      psychologic: 'Próxima categoría: zona íntima. Son de las que más cuesta hablar, pero aquí te escuchamos.',
      urogenital: 'Próxima categoría: otros cambios',
      corporalChanges: 'Unas preguntas más y te mostramos en qué etapa estás.'
    },
    birthError: 'Escribe tu fecha de nacimiento para continuar.',
    remaining: function (n) { return n === 1 ? 'Te queda 1 pregunta' : 'Te quedan ' + n + ' preguntas'; },
    back: 'Atrás',
    next: 'Siguiente →',
    seeResult: 'Ver mi resultado →',
    loading: ['Sumando tus respuestas', 'Revisando tus 4 áreas', 'Viendo en qué etapa estás'],
    chapterOf: function (n, total) { return n + ' de ' + total; },
    revealOver: 'Tu resultado',
    topFlag: 'Donde más te afecta',
    stagePre: 'Pre-|menopausia',
    stagePeri: 'Peri-|menopausia',
    stagePost: 'Post-|menopausia',
    bookShort: 'Agendar',
    topAreaTitle: 'Tu área más afectada',
    debugTitle: 'Datos enviados (modo de prueba)'
  };

  var CHAPTERS = [
    { id: 'reveal', label: 'Tu resultado' },
    { id: 'map', label: 'Tus síntomas', next: '¿Dónde te está afectando más? →' },
    { id: 'why', label: 'Tu área más afectada', next: 'Tu área más afectada →' },
    { id: 'stage', label: 'Tu etapa', next: '¿En qué etapa estás? →' },
    { id: 'future', label: 'Sentirte mejor', next: 'Sentirte mejor →' },
    // "Esto dicen nuestras pacientes" no cabe en el encabezado en móvil; ahí queda "Mujeres como tú".
    { id: 'women', label: 'Mujeres como tú', next: 'Esto dicen nuestras pacientes →' },
    { id: 'consult', label: 'Tu consulta', next: 'Quiero recibir ayuda →' }
  ];

  var SECTIONS = [
    { id: 'som', label: 'Síntomas físicos' },
    { id: 'psi', label: 'Ánimo y mente' },
    { id: 'uro', label: 'Zona íntima' },
    { id: 'otros', label: 'Otros cambios' },
    { id: 'etapa', label: 'Tu etapa' },
    { id: 'contexto', label: 'Tu contexto' },
    { id: 'final', label: 'Tu resultado' }
  ];

  // Preguntas del Typeform EAhRHgrN (ver typeform-actual.md). El nombre se pide en la pantalla de entrada.
  var STEPS = [
    { id: 'bochornos', section: 'som', type: 'scale', intro: 'Vamos a revisar posibles síntomas ahora.', symptom: 'Bochornos, sudoración, calores' },
    { id: 'corazon', section: 'som', type: 'scale', symptom: 'Molestias al corazón', detail: 'Sentir latidos del corazón, palpitaciones, o presión al pecho.' },
    { id: 'articulaciones', section: 'som', type: 'scale', symptom: 'Molestias musculares y articulares', detail: 'Dolores de huesos y articulaciones, dolores reumáticos.' },
    { id: 'sueno', section: 'som', type: 'scale', symptom: 'Dificultades en el sueño', detail: 'Insomnio, duermes poco y/o mal.' },
    { id: 'insight_som', section: 'som', type: 'insight', area: 'somatic' },

    { id: 'animo', section: 'psi', type: 'scale', symptom: 'Estado de ánimo depresivo', detail: 'Sentirse deprimida, decaída, triste a punto de llorar, sin ganas de vivir.' },
    { id: 'irritabilidad', section: 'psi', type: 'scale', symptom: 'Irritabilidad', detail: 'Sentirse tensa, explotas fácil, sentirse rabiosa, sentirse intolerante.' },
    { id: 'ansiedad', section: 'psi', type: 'scale', symptom: 'Ansiedad', detail: 'Sentirse angustiada, temerosa, inquieta, tendencia al pánico.' },
    { id: 'cansancio', section: 'psi', type: 'scale', symptom: 'Cansancio físico y mental', detail: 'Rinde menos, se cansa fácil, olvidos frecuentes, mala memoria, le cuesta concentrarse.' },
    { id: 'insight_psi', section: 'psi', type: 'insight', area: 'psychologic' },

    { id: 'sexual', section: 'uro', type: 'scale', symptom: 'Problemas sexuales', detail: 'Menos ganas de sexo, menor frecuencia de relaciones sexuales, menor satisfacción sexual.' },
    { id: 'orina', section: 'uro', type: 'scale', symptom: 'Problemas con la orina', detail: 'Problemas al orinar, orinas más veces, urgencia al orinar, se te escapa la orina.' },
    { id: 'sequedad', section: 'uro', type: 'scale', symptom: 'Sequedad vaginal', detail: 'Sensación de genitales secos, malestar o ardor en los genitales, malestar o dolor con las relaciones sexuales.' },
    { id: 'insight_uro', section: 'uro', type: 'insight', area: 'urogenital' },

    { id: 'peso', section: 'otros', type: 'scale', symptom: 'Cambios en tu cuerpo y aumento de peso' },
    { id: 'ciclo', section: 'otros', type: 'scale', symptom: 'Irregularidad en tu ciclo menstrual', detail: 'Ciclos más cortos o más largos, sangrados más fuertes o más escasos que antes.' },
    { id: 'insight_corp', section: 'otros', type: 'insight', area: 'corporalChanges' },

    // Pregunta reescrita para que se entienda (pedido de Nathi, 2026-10-28). Sí → perimenopausia, No → postmenopausia.
    { id: 'menstruacion12m', section: 'etapa', type: 'choice', required: true,
      title: '¿Has tenido la regla en los últimos 12 meses?',
      desc: 'Cuenta cualquier regla, aunque haya sido irregular o distinta a como era antes.\n\nSi usas un anticonceptivo que te quita la regla, responde Sí.',
      options: [{ key: 'S', label: 'Sí, he tenido la regla este último año', value: 'si' }, { key: 'N', label: 'No, llevo más de 12 meses consecutivos sin regla', value: 'no' }] },
    { id: 'nacimiento', section: 'etapa', type: 'date', required: true,
      title: '{nombre}, ¿y tu fecha de nacimiento?',
      desc: 'Este nos ayuda a determinar tu edad y es otro buen indicador para saber en qué etapa estás.\n\n¿Sabías qué? La transición a la menopausia puede partir hasta 10 años antes de la última regla, es decir con +/- 40 años.' },
    { id: 'terapia', section: 'etapa', type: 'choice', required: true,
      title: '¿Actualmente estás utilizando Terapia de reemplazo hormonal (TRH) o anticonceptivos?',
      options: [
        { label: 'Terapia de reemplazo hormonal (p.ej. gel, pastillas, puff)', value: 'trh' },
        { label: 'Anticonceptivo hormonal', value: 'anticonceptivo' },
        { label: 'No', value: 'no' }] },

    { id: 'desahogo', section: 'contexto', type: 'longtext', required: false, title: 'Campo de desahogo',
      desc: '¿Qué es lo que más te está costando en el día a día? Cuéntanos con tus palabras, mientras más detalles, mejor. Si agendas una consulta, nuestra doctora lee esto antes de verte y llega preparada con tu caso.' },
    { id: 'prevision', section: 'contexto', type: 'choice', required: true,
      title: '¿Dónde te atiendes la mayoría de veces? Elige solo una opción.',
      options: [
        { label: 'Salud privada (Clínicas / consultas privadas / centros de salud (Redsalud, Integramédica, Policenter, etc))', value: 'privada' },
        { label: 'Salud pública (CESFAM, SAPU, Consultorio, Hospital)', value: 'publica' }] },
    { id: 'contacto', section: 'contexto', type: 'contact', required: true,
      title: '¿Cuál es tu número y dirección de correo electrónico?',
      desc: 'Te enviamos una copia de tu resultado por correo.' },
    // Opciones reducidas a las que llevan a atenderse (pedido de Nathi, 2026-10-28).
    { id: 'busca', section: 'contexto', type: 'choice', required: true,
      title: '¿Qué estás buscando en esta etapa de tu vida?',
      desc: 'En Neopausia te acompañamos paso a paso, déjanos saber qué te hace falta. Marca la opción más importante para ti en este momento.',
      options: [
        { label: 'Atenderme con una médica dedicada a la menopausia', value: 'medica' },
        { label: 'Creo que necesito apoyo de una psicóloga dedicada al tema', value: 'psicologa' },
        { label: 'Recibir ayuda y guía en mi nutrición y estilo de vida', value: 'nutricion' },
        { label: 'Primero entender bien qué me está pasando', value: 'entender' }] },
    { id: 'orientacion', section: 'contexto', type: 'choice', required: true,
      title: '¿Te gustaría recibir orientación profesional sobre cómo manejar los cambios que estás experimentando en tu cuerpo?',
      options: [
        { label: 'No estoy segura de que necesite ayuda profesional', value: 'no_segura' },
        { label: 'Sí, pero me gustaría conocer más sobre las opciones antes de tomar una decisión', value: 'conocer_mas' },
        { label: 'Sí, estoy lista para agendar una consulta', value: 'lista' }] },

    { id: 'privacidad', section: 'final', type: 'consent', required: true, title: '¡Último paso!' }
  ];

  var AREA_ITEMS = {
    somatic: ['bochornos', 'corazon', 'articulaciones', 'sueno'],
    psychologic: ['animo', 'irritabilidad', 'ansiedad', 'cansancio'],
    urogenital: ['sexual', 'orina', 'sequedad'],
    corporalChanges: ['peso']
  };
  var AREA_KEYS = ['somatic', 'psychologic', 'urogenital', 'corporalChanges'];
  var SECTION_AREA = { som: 'somatic', psi: 'psychologic', uro: 'urogenital', otros: 'corporalChanges' };
  // Encuadre vertical (background-position y, en %) para que no se corten las caras.
  // Calculado sobre las fotos actuales; si se cambia una foto hay que revisarlo.
  var QUESTION_FOCUS = { bochornos: 40, corazon: 32, articulaciones: 40, sueno: 50, animo: 30, irritabilidad: 20, ansiedad: 40, cansancio: 20, sexual: 40, orina: 50, sequedad: 50, peso: 30, ciclo: 50 };
  var AREA_FOCUS = { somatic: 40, psychologic: 20, urogenital: 10, corporalChanges: 5 };
  var AREA_ORDER = ['urogenital', 'psychologic', 'somatic', 'corporalChanges'];
  var LEVEL_COLOR = { Bajo: 'var(--nts-low)', Medio: 'var(--nts-mid)', Alto: 'var(--nts-high)' };
  var LEVEL_RANK = { Bajo: 1, Medio: 2, Alto: 3 };
  var QUESTION_TYPES = ['scale', 'choice', 'date', 'longtext', 'contact', 'consent'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function arrow(s) { return s.replace(/ →$/, '\u00a0→'); }
  function fmt(n) { return n.toLocaleString('es-CL', { maximumFractionDigits: 1 }); }
  function isQuestion(s) { return QUESTION_TYPES.indexOf(s.type) !== -1; }
  // En Shopify, GTM corre como píxel personalizado aislado de la página y no ve window.dataLayer.
  // Por eso cada evento también se publica a Shopify, y el píxel lo reenvía a GTM (ver shopify/pixel/).
  function track(event, params) {
    window.dataLayer = window.dataLayer || [];
    var data = { event: event };
    for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) data[k] = params[k];
    window.dataLayer.push(data);
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('neopausia:' + event, params);
    } catch (e) { /* la medición nunca debe romper el test */ }
    // Clarity: un evento por hito, y etiquetas con lo último que vio para filtrar grabaciones por abandono.
    if (typeof window.clarity === 'function') {
      window.clarity('event', event);
      if (params.step_id) window.clarity('set', 'test_sintomas_ultimo_paso', params.step_id);
      if (params.chapter && event === 'test_sintomas_result_chapter') window.clarity('set', 'test_sintomas_ultimo_capitulo', params.chapter);
    }
  }
  function trackingParams() {
    var out = {};
    try {
      var q = new URLSearchParams(window.location.search);
      TRACKING_PARAMS.forEach(function (k) { if (q.get(k)) out[k] = q.get(k); });
    } catch (e) { /* URL sin parámetros legibles */ }
    return out;
  }

  function mount(root) {
    if (root.__nts) return;
    var cfgEl = root.querySelector('[data-nts-config]');
    var view = root.querySelector('[data-nts-view]');
    if (!cfgEl || !view) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    root.__nts = true;
    createApp(root, view, cfg);
  }

  function createApp(root, view, cfg) {
    var uid = root.id || 'nts';
    var bookingUrl = cfg.bookingUrl || 'https://app.neopausia.com/agendar';
    var privacyUrl = cfg.privacyUrl || '/policies/privacy-policy';
    var images = cfg.images || {};
    var tracking = trackingParams();
    var answers = {};
    var idx = 0;
    var phase = 'hook';
    var timer = null;
    var R = null;
    var chapter = 0;
    var furthestChapter = 0;

    function q(sel) { return view.querySelector(sel); }
    function qa(sel) { return Array.prototype.slice.call(view.querySelectorAll(sel)); }
    function firstName() { return answers.nombre || ''; }
    // El nombre y el desahogo van marcados para que Clarity no los grabe.
    function nameHtml() { return '<span data-clarity-mask="True">' + esc(firstName()) + '</span>'; }
    function fill(t) { return t.replace('{nombre}', firstName() ? nameHtml() : 'Y'); }
    function areaImg(key) { return images[key] || ASSETS + OWNER_COPY.areas[key].img; }
    function areaBg(key) { return 'background-image:url(\'' + esc(areaImg(key)) + '\');background-position:center ' + AREA_FOCUS[key] + '%'; }
    // Cada pregunta de síntomas tiene su propia foto (las del Typeform); si falta, se usa la del grupo.
    function questionImg(step) { return (cfg.questionImages || {})[step.id] || areaImg(SECTION_AREA[step.section]); }
    function preloadNextImage() {
      var nextScale = STEPS.slice(idx + 1).filter(function (s) { return s.type === 'scale'; })[0];
      if (nextScale) { var im = new Image(); im.src = questionImg(nextScale); }
    }

    // Lleva la sección a la vista solo si su parte de arriba quedó fuera de pantalla.
    function scrollIntoPlace() {
      var top = root.querySelector('.nts__inner').getBoundingClientRect().top;
      var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height')) || 0;
      if (top < header || top > window.innerHeight * 0.4) {
        window.scrollTo({ top: window.pageYOffset + top - header - 12, behavior: 'smooth' });
      }
    }
    function growBars() {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          qa('.nts-bar i[data-w]').forEach(function (i) { i.style.width = i.getAttribute('data-w'); });
        });
      });
    }
    function levelRow(level, pct) {
      return '<div class="nts-level"><div class="nts-bar"><i style="background:' + LEVEL_COLOR[level] + '" data-w="' + pct + '%"></i></div>' +
        '<span class="nts-pill" style="background:' + LEVEL_COLOR[level] + '">' + level + '</span></div>';
    }

    // ---------- Puntaje ----------
    function sum(ids) { return ids.reduce(function (t, id) { return t + (answers[id] || 0); }, 0); }
    function areaLevel(key, score) {
      var c = OWNER_COPY.areas[key].cuts;
      return score <= c[0] ? 'Bajo' : score <= c[1] ? 'Medio' : 'Alto';
    }
    function scores() {
      var s = {};
      AREA_KEYS.forEach(function (k) { s[k] = sum(AREA_ITEMS[k]); });
      s.full = s.somatic + s.psychologic + s.urogenital;
      return s;
    }
    function totalLevel(full) { return OWNER_COPY.total.filter(function (t) { return full <= t.max; })[0]; }
    function stageName() { return answers.menstruacion12m === 'no' ? 'postmenopausia' : 'perimenopausia'; }
    function topArea(s) {
      function lvl(k) { return LEVEL_RANK[areaLevel(k, s[k])]; }
      var main = ['urogenital', 'psychologic', 'somatic'];
      var onlyCorporalHigh = lvl('corporalChanges') === 3 && main.every(function (k) { return lvl(k) !== 3; });
      var pool = onlyCorporalHigh ? main.concat('corporalChanges') : main.slice();
      return pool.sort(function (a, b) {
        return lvl(b) - lvl(a)
          || s[b] / OWNER_COPY.areas[b].max - s[a] / OWNER_COPY.areas[a].max
          || AREA_ORDER.indexOf(a) - AREA_ORDER.indexOf(b);
      })[0];
    }
    function age() {
      var n = answers.nacimiento;
      if (!n || !n.anio) return null;
      var b = new Date(Number(n.anio), Number(n.mes) - 1, Number(n.dia));
      var now = new Date();
      var a = now.getFullYear() - b.getFullYear();
      if (now < new Date(now.getFullYear(), b.getMonth(), b.getDate())) a -= 1;
      return a;
    }

    // ---------- Pantalla de entrada ----------
    function renderHook() {
      phase = 'hook';
      var h = cfg.hook || {};
      var img = h.image;
      view.innerHTML =
        '<div class="nts-hook' + (img ? '' : ' nts-hook--noimg') + '">' +
          (img ? '<div class="nts-hook__media"><img src="' + esc(img.src) + '"' + (img.srcset ? ' srcset="' + esc(img.srcset) + '" sizes="(min-width: 768px) 560px, 100vw"' : '') +
            ' alt="' + esc(img.alt) + '" width="' + esc(img.width) + '" height="' + esc(img.height) + '" loading="lazy"></div>' : '') +
          '<div class="nts-hook__body">' +
            (h.eyebrow ? '<p class="nts-over">' + esc(h.eyebrow) + '</p>' : '') +
            '<h2 class="nts-hook__title">' + esc(h.heading) + '</h2>' +
            (h.text ? '<p class="nts-hook__text">' + esc(h.text) + '</p>' : '') +
            '<form class="nts-hook__form" novalidate>' +
              '<label for="' + uid + '-name">' + OWNER_COPY.nameQuestion + '</label>' +
              '<div class="nts-hook__row">' +
                '<input class="nts-input" id="' + uid + '-name" name="nombre" autocomplete="given-name" placeholder="' + DRAFT_COPY.namePlaceholder + '" value="' + esc(answers.nombre || '') + '">' +
                '<button type="submit" class="nts-btn">' + esc(h.button || 'Empezar') + '</button>' +
              '</div>' +
              '<p class="nts-error" role="alert"></p>' +
            '</form>' +
          '</div>' +
        '</div>';
      q('form').addEventListener('submit', function (e) {
        e.preventDefault();
        var name = q('input').value.trim();
        if (!name) { q('.nts-error').textContent = DRAFT_COPY.nameError; q('input').focus(); return; }
        answers.nombre = name;
        track('test_sintomas_start', {});
        idx = 0;
        renderQuiz();
        scrollIntoPlace();
      });
    }

    // ---------- Test ----------
    function sectionLabel(id) { return SECTIONS.filter(function (s) { return s.id === id; })[0].label; }
    function optionButton(key, label, value, selected, meterLevel) {
      var meter = meterLevel === undefined ? '' : '<span class="nts-meter" aria-hidden="true">' +
        [1, 2, 3, 4].map(function (n) { return '<i' + (n <= meterLevel ? ' class="is-on"' : '') + '></i>'; }).join('') + '</span>';
      return '<button type="button" class="nts-opt" data-value="' + esc(value) + '" data-key="' + key + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
        '<span class="nts-opt__key">' + key + '</span><span class="nts-opt__lbl">' + esc(label) + '</span>' + meter + '</button>';
    }

    // Mejora medida en MUSA 2026: cifras grandes primero y la fuente como nota.
    function improveBox(key) {
      var a = OWNER_COPY.areas[key];
      if (!a.improvements) return '<div class="nts-box"><b>' + a.boxLabel + '</b><p>' + a.boxData + '</p></div>';
      return '<div class="nts-improve"><p class="nts-improve__title">' + OWNER_COPY.improveTitle + '</p>' +
        '<div class="nts-improve__grid">' + a.improvements.map(function (m) { return '<div><b>' + m[0] + '</b><span>' + m[1] + '</span></div>'; }).join('') + '</div>' +
        (key === 'psychologic' ? '<p class="nts-improve__extra">' + DRAFT_COPY.psychTeam + '</p>' : '') +
        '<p class="nts-improve__note">' + OWNER_COPY.improveNote + '</p></div>';
    }

    function insightHtml(step) {
      var key = step.area;
      var area = OWNER_COPY.areas[key];
      var score = sum(AREA_ITEMS[key]);
      var level = areaLevel(key, score);
      var title = key === 'urogenital' ? DRAFT_COPY.partialTitleUro
        : key === 'corporalChanges' ? DRAFT_COPY.partialTitleCorporal
        : DRAFT_COPY.partialTitle(area.name);
      var body = level === 'Bajo'
        ? '<p class="nts-lead" style="margin-top:16px">' + DRAFT_COPY.lowLevel + '</p>'
        : '<p class="nts-lead" style="margin-top:16px">' + DRAFT_COPY.groupLine[key] + '</p>' +
          improveBox(key) +
          '<p class="nts-close">💜 ' + DRAFT_COPY.groupClose[key] + '</p>';
      var levels = levelRow(level, (score / area.max) * 100);
      if (key === 'corporalChanges') {
        var c = corporalPartial();
        levels = c.levels;
        body = c.body;
      }
      // La foto va limpia, sin texto encima, para no tapar la cara.
      return '<div class="nts-hero nts-hero--plain" role="img" aria-label="' + esc(cap(area.name)) + '" style="' + areaBg(key) + '"></div>' +
        '<div class="nts-q__tag" style="margin-top:16px">' + DRAFT_COPY.partialTag(AREA_KEYS.indexOf(key) + 1, 4) + '</div>' +
        '<h2 tabindex="-1" style="margin-top:6px">' + title + '</h2>' +
        levels + body;
    }

    // "Otros cambios" junta dos síntomas distintos: peso y ciclo. El MRS solo puntúa el peso,
    // pero el parcial muestra cada uno con su nivel y habla del que le afecta, o de ambos.
    function corporalPartial() {
      var cuts = OWNER_COPY.areas.corporalChanges.cuts;
      var affected = ['peso', 'ciclo'].filter(function (id) { return (answers[id] || 0) > cuts[0]; });
      var levels = ['peso', 'ciclo'].map(function (id) {
        var v = answers[id] || 0;
        var lvl = v <= cuts[0] ? 'Bajo' : v <= cuts[1] ? 'Medio' : 'Alto';
        return '<div class="nts-sublevel"><span>' + DRAFT_COPY.corporalItems[id] + '</span>' + levelRow(lvl, (v / 4) * 100) + '</div>';
      }).join('');
      if (!affected.length) return { levels: levels, body: '<p class="nts-lead" style="margin-top:16px">' + DRAFT_COPY.lowLevel + '</p>' };
      var lines = affected.map(function (id) {
        return '<p class="nts-lead" style="margin-top:16px">' + (id === 'peso' ? DRAFT_COPY.groupLine.corporalChanges : DRAFT_COPY.cycleLine) + '</p>';
      }).join('');
      // La caja de nutrición solo aplica al peso.
      var box = affected.indexOf('peso') !== -1 ? improveBox('corporalChanges') : '';
      return { levels: levels, body: lines + box + '<p class="nts-close">💜 ' + DRAFT_COPY.groupClose.corporalChanges + '</p>' };
    }

    function stepHtml(step) {
      var val = answers[step.id];
      var inSection = STEPS.filter(function (s) { return s.section === step.section && isQuestion(s); });
      var pos = inSection.indexOf(step);
      var tag = '<div class="nts-q__tag">' + sectionLabel(step.section) + (inSection.length > 1 && pos >= 0 ? ' · ' + (pos + 1) + ' de ' + inSection.length : '') + '</div>';
      var req = step.required || step.type === 'scale' ? ' <span class="nts-req">*</span>' : '';
      var v;

      if (step.type === 'scale') {
        return '<div class="nts-qgrid"><div class="nts-q__photo" aria-hidden="true" style="background-image:url(\'' + esc(questionImg(step)) + '\');background-position:center ' + (QUESTION_FOCUS[step.id] || 50) + '%"></div><div>' +
          tag + (step.intro ? '<p class="nts-q__intro">' + step.intro + '</p>' : '') +
          '<p class="nts-q__ask">¿Con cuánta intensidad sientes…</p>' +
          '<h2 tabindex="-1">' + step.symptom + req + '</h2>' +
          (step.detail ? '<p class="nts-q__detail">' + step.detail + '</p>' : '') +
          '<div class="nts-options" role="group">' + SCALE.map(function (l, i) { return optionButton('ABCDE'[i], l, i, val === i, i); }).join('') + '</div></div></div>';
      }
      if (step.type === 'choice') {
        return tag + '<h2 tabindex="-1">' + fill(step.title) + req + '</h2>' +
          (step.desc ? '<p class="nts-q__desc">' + step.desc + '</p>' : '') +
          '<div class="nts-options" role="group">' + step.options.map(function (o, i) { return optionButton(o.key || 'ABCDEFG'[i], o.label, o.value, val === o.value); }).join('') + '</div>';
      }
      if (step.type === 'date') {
        v = val || {};
        return tag + '<h2 tabindex="-1">' + fill(step.title) + req + '</h2><p class="nts-q__desc">' + step.desc + '</p>' +
          '<div class="nts-field"><label>Fecha de nacimiento *</label><div class="nts-date">' +
          '<input class="nts-input" data-date="dia" inputmode="numeric" maxlength="2" placeholder="DD" aria-label="Día" value="' + esc(v.dia || '') + '">' +
          '<input class="nts-input" data-date="mes" inputmode="numeric" maxlength="2" placeholder="MM" aria-label="Mes" value="' + esc(v.mes || '') + '">' +
          '<input class="nts-input" data-date="anio" inputmode="numeric" maxlength="4" placeholder="AAAA" aria-label="Año" value="' + esc(v.anio || '') + '">' +
          '</div></div>';
      }
      if (step.type === 'longtext') {
        return tag + '<h2 tabindex="-1">' + step.title + '</h2><p class="nts-q__desc">' + step.desc + '</p>' +
          '<div class="nts-field"><textarea class="nts-input" data-long placeholder="Escribe aquí…" aria-label="' + step.title + '">' + esc(val || '') + '</textarea><p class="nts-hint">Opcional</p></div>';
      }
      if (step.type === 'contact') {
        v = val || {};
        return tag + '<h2 tabindex="-1">' + step.title + req + '</h2><p class="nts-q__desc">' + step.desc + '</p>' +
          '<div class="nts-field"><label for="' + uid + '-tel">Número de teléfono</label><input class="nts-input" id="' + uid + '-tel" data-tel type="tel" autocomplete="tel" placeholder="+56 9 1234 5678" value="' + esc(v.telefono || '') + '"></div>' +
          '<div class="nts-field"><label for="' + uid + '-email">Correo electrónico *</label><input class="nts-input" id="' + uid + '-email" data-email type="email" autocomplete="email" placeholder="nombre@ejemplo.com" value="' + esc(v.email || '') + '"></div>';
      }
      if (step.type === 'consent') {
        return tag + '<h2 tabindex="-1">' + step.title + req + '</h2>' +
          '<p class="nts-q__desc">Para entregarte tu resultado necesitamos que aceptes nuestra <a href="' + esc(privacyUrl) + '" target="_blank" rel="noopener">Política de Privacidad</a>.<br><br>Al presionar "Acepto" te llevamos a tu página con resultado y recomendaciones.</p>' +
          '<div class="nts-options" role="group">' + optionButton('A', 'Acepto', 'acepto', val === 'acepto') + '</div>';
      }
      if (step.type === 'insight') return insightHtml(step);
      return '';
    }

    function renderQuiz() {
      phase = 'quiz';
      var step = STEPS[idx];
      var questions = STEPS.filter(isQuestion);
      var answered = STEPS.slice(0, idx).filter(isQuestion).length;
      var left = questions.length - answered;
      var nextCat = step.type === 'insight' ? DRAFT_COPY.nextCategory[step.area] : null;
      var nextLabel = step.type === 'consent' ? DRAFT_COPY.seeResult : DRAFT_COPY.next;
      view.innerHTML =
        '<div class="nts-quiz">' +
          '<div class="nts-progress"><div class="nts-progress__row"><b>' + sectionLabel(step.section) + '</b><span>' + DRAFT_COPY.remaining(left) + '</span></div>' +
          '<div class="nts-progress__track"><i style="width:' + (answered / questions.length) * 100 + '%"></i></div></div>' +
          '<div class="nts-stage"><div class="nts-q">' + stepHtml(step) + '<p class="nts-error" role="alert"></p></div></div>' +
          '<div class="nts-nav' + (nextCat ? ' nts-nav--next-cat' : '') + '"><div class="nts-toast" aria-live="polite"></div>' +
            (nextCat ? '<p class="nts-nav__hint">' + nextCat + '</p>' : '') +
            '<button type="button" class="nts-btn nts-btn--ghost" data-back aria-label="' + DRAFT_COPY.back + '">← <span class="nts-back-txt">' + DRAFT_COPY.back + '</span></button>' +
            '<button type="button" class="nts-btn" data-next>' + nextLabel + '</button>' +
          '</div>' +
        '</div>';
      preloadNextImage();
      bindStep(step);
      growBars();
      track('test_sintomas_step', { step_id: step.id, step_index: idx + 1 });
      var input = q('.nts-stage input, .nts-stage textarea');
      if (input && window.matchMedia('(min-width: 768px)').matches) input.focus({ preventScroll: true });
      else { var h = q('.nts-stage h2'); if (h) h.focus({ preventScroll: true }); }
    }

    function bindStep(step) {
      qa('.nts-opt').forEach(function (b) { b.addEventListener('click', function () { choose(step, b); }); });
      q('[data-next]').addEventListener('click', next);
      q('[data-back]').addEventListener('click', back);
      // Fecha: pasa solo al siguiente campo al completar DD y MM.
      var dateInputs = qa('[data-date]');
      dateInputs.forEach(function (el, i) {
        el.addEventListener('input', function () { if (i < 2 && el.value.length === 2) dateInputs[i + 1].focus(); });
      });
    }

    function choose(step, btn) {
      var raw = btn.getAttribute('data-value');
      qa('.nts-opt').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      answers[step.id] = step.type === 'scale' ? Number(raw) : raw;
      clearTimeout(timer);
      q('.nts-toast').innerHTML = '';
      var safety = q('[data-safety]');
      if (safety) safety.remove();
      if (step.type === 'scale' && Number(raw) >= 3) {
        // Ánimo depresivo alto: la línea de ayuda queda fija y no se avanza sola.
        if (step.id === 'animo') {
          q('.nts-options').insertAdjacentHTML('afterend', '<div class="nts-box nts-safety" data-safety role="note"><p>' +
            DRAFT_COPY.validateHigh.animo + '</p><p><strong>' + DRAFT_COPY.moodSafety + '</strong></p></div>');
          return;
        }
        // Mensaje de validación del síntoma, con tiempo para leerlo.
        q('.nts-toast').innerHTML = '<span>💜 ' + DRAFT_COPY.validateHigh[step.id] + '</span>';
        timer = setTimeout(next, 3200);
        return;
      }
      timer = setTimeout(next, 320);
    }

    function collect(step) {
      function val(sel) { var el = q(sel); return el ? el.value.trim() : ''; }
      if (step.type === 'date') answers.nacimiento = { dia: val('[data-date="dia"]'), mes: val('[data-date="mes"]'), anio: val('[data-date="anio"]') };
      if (step.type === 'longtext') answers.desahogo = val('[data-long]');
      if (step.type === 'contact') answers.contacto = { telefono: val('[data-tel]'), email: val('[data-email]') };
    }

    function validate(step) {
      var a = answers[step.id];
      if (step.type === 'scale' && a === undefined) return 'Elige una opción para continuar.';
      if (step.type === 'choice' && step.required && !a) return 'Elige una opción para continuar.';
      if (step.type === 'contact') {
        if (!a.email) return 'Escribe tu correo para continuar.';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(a.email)) return 'Revisa que el correo esté bien escrito.';
      }
      if (step.type === 'date') {
        if (!a.dia || !a.mes || !a.anio) return DRAFT_COPY.birthError;
        var d = new Date(Number(a.anio), Number(a.mes) - 1, Number(a.dia));
        var years = (Date.now() - d.getTime()) / 31557600000;
        var ok = a.anio.length === 4 && d.getDate() === Number(a.dia) && d.getMonth() === Number(a.mes) - 1 && years >= 18 && years <= 100;
        if (!ok) return 'Revisa la fecha de nacimiento.';
      }
      if (step.type === 'consent' && a !== 'acepto') return 'Necesitamos que aceptes la Política de Privacidad para mostrarte tu resultado.';
      return '';
    }

    function next() {
      clearTimeout(timer);
      if (phase !== 'quiz') return;
      var step = STEPS[idx];
      collect(step);
      var err = validate(step);
      if (err) { q('.nts-error').textContent = err; return; }
      if (idx === STEPS.length - 1) { finish(); return; }
      idx += 1;
      renderQuiz();
      scrollIntoPlace();
    }

    function back() {
      clearTimeout(timer);
      collect(STEPS[idx]);
      if (idx === 0) { renderHook(); return; }
      idx -= 1;
      renderQuiz();
      scrollIntoPlace();
    }

    // ---------- Envío ----------
    function payload() {
      var n = answers.nacimiento;
      var additionalData = {
        birthday: n.anio + '-' + pad2(n.mes) + '-' + pad2(n.dia),
        lookingFor: CORE_LABELS.busca[answers.busca],
        healthcareSystem: CORE_LABELS.prevision[answers.prevision],
        getOrientation: CORE_LABELS.orientacion[answers.orientacion],
        lastMenstruationInLast12Months: answers.menstruacion12m === 'si',
        hormonalTherapy: answers.terapia,
        relief: (answers.desahogo || '').slice(0, 5000)
      };
      Object.keys(SYMPTOM_FIELDS).forEach(function (id) { additionalData[SYMPTOM_FIELDS[id]] = answers[id]; });
      return {
        // La página de anuncios es /pages/test-sintomas; el resto es el home.
        source: /^\/pages\//.test(window.location.pathname) ? 'shopify-ads-page' : 'shopify-home',
        submissionId: newSubmissionId(),
        tracking: tracking,
        firstName: firstName().slice(0, 100),
        email: answers.contacto.email,
        phone: answers.contacto.telefono ? answers.contacto.telefono.slice(0, 30) : null,
        additionalData: additionalData
      };
    }

    function submit(data) {
      if (!cfg.submitUrl) {
        if (window.console) console.warn('[test-sintomas] Sin "URL que recibe las respuestas": no se envió nada.');
        return;
      }
      var body = JSON.stringify(data);
      function send(attempt) {
        fetch(cfg.submitUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true })
          .then(function (r) {
            if (r.ok) { track('test_sintomas_submit_ok', {}); return; }
            // 400, 403 y 429 no se reintentan: repetir el mismo envío da el mismo resultado.
            if (r.status < 500) { track('test_sintomas_submit_error', {}); return; }
            throw new Error('HTTP ' + r.status);
          })
          .catch(function () {
            if (attempt < 2) setTimeout(function () { send(attempt + 1); }, 1500);
            else track('test_sintomas_submit_error', {});
          });
      }
      send(1);
    }

    // Pantalla de carga: cada paso corresponde a un cálculo que de verdad se hace.
    function finish() {
      phase = 'loading';
      var s = scores();
      R = {
        s: s, tl: totalLevel(s.full), top: topArea(s), stage: stageName(), age: age(),
        relief: (answers.desahogo || '').trim(), data: payload()
      };
      R.tlColor = R.tl.max === 7 ? 'var(--nts-low)' : R.tl.max === 14 ? 'var(--nts-mid)' : 'var(--nts-high)';
      submit(R.data);
      track('test_sintomas_complete', { score: s.full, level: R.tl.label, stage: R.stage, looking_for: answers.busca || '' });

      view.innerHTML = '<div class="nts-loading"><div><div class="nts-spinner"></div><ul class="nts-load-steps">' +
        DRAFT_COPY.loading.map(function (t) { return '<li>' + t + '</li>'; }).join('') + '</ul></div></div>';
      scrollIntoPlace();
      var items = qa('.nts-load-steps li');
      items.forEach(function (li, i) { setTimeout(function () { li.classList.add('is-done'); }, 500 + i * 550); });
      setTimeout(function () { chapter = 0; renderChapter(); }, 500 + items.length * 550 + 300);
    }

    // ---------- Resultado: recorrido por capítulos ----------
    function areaCard(key) {
      var a = OWNER_COPY.areas[key];
      var score = R.s[key];
      var lvl = areaLevel(key, score);
      var isTop = key === R.top;
      return '<div class="nts-area' + (isTop ? ' is-top' : '') + '">' +
        '<div class="nts-area__img" role="img" aria-label="' + esc(a.card) + '" style="' + areaBg(key) + '">' +
          (isTop ? '<span class="nts-area__flag">' + DRAFT_COPY.topFlag + '</span>' : '') +
          '<span class="nts-pill" style="background:' + LEVEL_COLOR[lvl] + '">' + lvl + '</span></div>' +
        '<div class="nts-area__body"><h3>' + a.card + '</h3><p>' + a.desc + '</p>' +
          '<div class="nts-area__score"><div class="nts-bar"><i style="background:' + LEVEL_COLOR[lvl] + '" data-w="' + (score / a.max) * 100 + '%"></i></div><b>' + score + ' de ' + a.max + '</b></div>' +
        '</div></div>';
    }

    // Escala del puntaje total en tres tramos iguales (leve 0–7, moderado 8–14, importante 15–44),
    // con su posición marcada, para que se lea que un puntaje más bajo es mejor.
    function scoreScale(full) {
      var segs = [[0, 7], [8, 14], [15, 44]];
      var i = full <= 7 ? 0 : full <= 14 ? 1 : 2;
      var frac = (full - segs[i][0]) / (segs[i][1] - segs[i][0] + 1);
      var pos = ((i + frac) / 3) * 100;
      var colors = ['var(--nts-low)', 'var(--nts-mid)', 'var(--nts-high)'];
      return '<div class="nts-scale"><div class="nts-scale__bar">' +
          DRAFT_COPY.scaleLabels.map(function (l, k) { return '<span style="background:' + colors[k] + (k === i ? '' : ';opacity:.35') + '">' + l + '</span>'; }).join('') +
          '<i class="nts-scale__you" style="left:' + pos + '%">Tú</i></div>' +
        '<div class="nts-scale__ends"><span>0</span><span>44</span></div></div>' +
        '<p class="nts-scale-hint">' + DRAFT_COPY.scoreHint + '</p>';
    }

    // Curva simplificada de estrógeno por edad, con la etapa de la paciente marcada.
    function stageChart() {
      // Eje de 30 a 70 años. La perimenopausia parte a los 40 para que el pin quede cerca de su edad
      // (decisión de Nathi, 2026-10-29); el pin se ajusta al tramo de su etapa, que manda sobre la edad.
      function x(a) { return 16 + ((a - 30) / 40) * 368; }
      var ranges = { pre: [30, 40], peri: [40, 51], post: [51, 70] };
      var isPeri = R.stage === 'perimenopausia';
      var r = isPeri ? ranges.peri : ranges.post;
      var at = R.age ? Math.min(r[1] - 0.5, Math.max(r[0] + 0.5, R.age)) : (isPeri ? 48 : 56);
      var curve = 'M' + x(30) + ',82 C' + x(36) + ',80 ' + x(39) + ',84 ' + x(42) + ',92 S' + x(45) + ',80 ' + x(46.5) + ',112 S' + x(48.5) + ',100 ' + x(50) + ',150 S' + x(52) + ',182 ' + x(56) + ',196 S' + x(66) + ',203 ' + x(70) + ',205';
      function band(rr, label, active) {
        var cx = (x(rr[0]) + x(rr[1])) / 2;
        var parts = label.split('|');
        var style = ' text-anchor="middle" font-size="' + (active ? 13 : 11) + '" font-weight="' + (active ? 700 : 500) + '" fill="' + (active ? '#2a5b54' : '#6b7d7a') + '"';
        return '<rect x="' + x(rr[0]) + '" y="30" width="' + (x(rr[1]) - x(rr[0])) + '" height="190" fill="' + (active ? '#f3ecfb' : '#f5f8f7') + '"/>' +
          '<text x="' + cx + '" y="48"' + style + '>' + parts[0] + '</text>' +
          '<text x="' + cx + '" y="' + (active ? 63 : 61) + '"' + style + '>' + parts[1] + '</text>';
      }
      var mx = Math.min(400 - 64, Math.max(64, x(at)));
      return '<svg class="nts-chart" viewBox="0 0 400 270" role="img" aria-label="' + OWNER_COPY.stage.title + '" font-family="Montserrat, sans-serif">' +
        band(ranges.pre, DRAFT_COPY.stagePre, false) +
        band(ranges.peri, DRAFT_COPY.stagePeri, isPeri) +
        band(ranges.post, DRAFT_COPY.stagePost, !isPeri) +
        '<path d="' + curve + '" fill="none" stroke="#2a5b54" stroke-width="3.5" stroke-linecap="round"/>' +
        '<line x1="' + x(at) + '" y1="72" x2="' + x(at) + '" y2="220" stroke="#c24f4f" stroke-width="1.5" stroke-dasharray="4 3"/>' +
        '<rect x="' + (mx - 60) + '" y="222" width="120" height="26" rx="13" fill="#c24f4f"/>' +
        '<text x="' + mx + '" y="240" text-anchor="middle" font-size="13" font-weight="700" fill="#fff">' + OWNER_COPY.stage.chartHere + '</text>' +
        [35, 40, 45, 50, 55, 60, 65, 70].map(function (a) { return '<text x="' + x(a) + '" y="266" text-anchor="middle" font-size="13" fill="#6b7d7a">' + a + '</text>'; }).join('') +
        '</svg>';
    }

    var CHAPTER_VIEWS = {
      reveal: function () {
        return '<div class="nts-reveal"><div class="nts-over">' + DRAFT_COPY.revealOver + '</div>' +
          '<h2 tabindex="-1">' + nameHtml() + ', ' + OWNER_COPY.resultTitle + '</h2>' +
          '<div class="nts-ring" style="--c:' + R.tlColor + '"><div class="nts-ring__in"><div><b data-ring-num>0</b><small>de 44</small></div></div></div>' +
          '<span class="nts-pill" style="background:' + R.tlColor + '">' + R.tl.label + '</span>' +
          scoreScale(R.s.full) +
          '<p class="nts-lead">' + R.tl.paragraph + '</p>' +
          '<div class="nts-badge"><span>📋</span><p>' + OWNER_COPY.mrsNote + '</p></div></div>';
      },
      map: function () {
        return '<h2 tabindex="-1">' + OWNER_COPY.areasTitle + '</h2><p class="nts-sub">' + OWNER_COPY.areasSub + '</p>' +
          '<div class="nts-areas">' + AREA_KEYS.map(areaCard).join('') + '</div>' +
          (R.relief ? '<div class="nts-told"><div class="nts-told__label">' + OWNER_COPY.toldUs + '</div><blockquote data-clarity-mask="True">"' + esc(R.relief) + '"</blockquote></div>' : '');
      },
      why: function () {
        var a = OWNER_COPY.areas[R.top];
        var statement = a.paragraphs.length > 1 ? a.paragraphs[a.paragraphs.length - 1] : '';
        return '<h2 tabindex="-1">' + DRAFT_COPY.topAreaTitle + '</h2>' +
          '<div class="nts-hero" role="img" aria-label="' + esc(cap(a.name)) + '" style="margin-top:16px;' + areaBg(R.top) + '">' +
            '<div class="nts-hero__cap"><p class="nts-hero__name">' + cap(a.name) + '</p></div></div>' +
          (statement ? '<p class="nts-statement">' + statement + '</p>' : '') +
          '<p class="nts-explain">' + a.paragraphs[0] + '</p>' +
          improveBox(R.top) +
          '<p class="nts-close">💜 ' + DRAFT_COPY.groupClose[R.top] + '</p>';
      },
      stage: function () {
        var st = OWNER_COPY.stage[R.stage];
        return '<h2 tabindex="-1">' + OWNER_COPY.stage.title + '</h2><p class="nts-sub">' + OWNER_COPY.stage.subtitle + '</p>' +
          '<div class="nts-panel">' + stageChart() + '<p class="nts-small" style="margin-top:8px;text-align:center">' + OWNER_COPY.stage.note + '</p></div>' +
          '<p class="nts-lead" style="margin-top:20px">' + st.lead + ' <strong>' + st.name + '</strong>' + st.rest + '</p>' +
          '<div class="nts-box"><b>' + st.tipTitle + '</b><p>' + st.tip + '</p></div>';
      },
      future: function () {
        var p = OWNER_COPY.projection;
        var full = R.s.full;
        var band = p.bands.filter(function (b) { return full >= b.min && full <= b.max; })[0] || p.bands[3];
        var active = band.name === 'moderado' || band.name === 'severo';
        if (!active) {
          return '<h2 tabindex="-1">' + p.titleLow + '</h2>' +
            '<div class="nts-panel"><p class="nts-lead">' + p.low1 + '</p><p class="nts-lead" style="margin-top:10px">' + p.low2(band.name) + '</p>' +
            '<p class="nts-strong">' + p.lowLine + '</p></div>' +
            '<p class="nts-small" style="margin-top:10px">' + p.lowNote + '</p>' +
            '<div class="nts-box"><b>' + p.whenTitle + '</b><p>' + p.when + '</p></div>';
        }
        var rows = [full, full + band.withDelta, full + band.withoutDelta];
        var deltas = [null, band.withDelta, band.withoutDelta];
        var colors = ['#8a9b98', 'var(--nts-green)', 'var(--nts-high)'];
        function deltaTag(d) {
          if (d === null) return '';
          if (Math.abs(d) < 0.5) return '<em class="nts-delta">' + DRAFT_COPY.deltaSame + '</em>';
          return d < 0 ? '<em class="nts-delta is-better">' + DRAFT_COPY.deltaDown(fmt(Math.abs(d))) + '</em>'
            : '<em class="nts-delta is-worse">' + DRAFT_COPY.deltaUp(fmt(d)) + '</em>';
        }
        return '<h2 tabindex="-1">' + p.titleActive + '</h2><p class="nts-sub">' + DRAFT_COPY.projHint + '</p>' +
          '<div class="nts-panel"><div class="nts-proj">' + rows.map(function (v, i) {
            var c = Math.max(0, Math.min(44, v));
            return '<div><div class="nts-proj__top"><span>' + p.labels[i] + ' ' + deltaTag(deltas[i]) + '</span><b>' + fmt(c) + '</b></div>' +
              '<div class="nts-bar"><i style="background:' + colors[i] + '" data-w="' + (c / 44) * 100 + '%"></i></div></div>';
          }).join('') + '</div>' +
          '<p class="nts-lead" style="margin-top:18px">' + (band.name === 'severo' ? p.severo : p.moderado) + '</p>' +
          '<p class="nts-strong">' + p.activeLine + '</p></div>' +
          '<p class="nts-small" style="margin-top:10px">' + p.activeNote + '</p>' +
          '<div class="nts-box"><b>' + p.whenTitle + '</b><p>' + p.when + p.whenActive + '</p></div>';
      },
      women: function () {
        return '<h2 tabindex="-1">' + OWNER_COPY.socialTitle + '</h2>' +
          '<div class="nts-photo nts-photo--group" role="img" aria-label="' + OWNER_COPY.socialTitle + '" style="background-image:url(\'' + esc(images.group || ASSETS + OWNER_COPY.groupImg) + '\')"></div>' +
          '<div class="nts-bigstats">' + OWNER_COPY.stats.map(function (s) { return '<div><b>' + s.value + '</b><span>' + s.label + '</span></div>'; }).join('') + '</div>' +
          '<div class="nts-reviews">' + OWNER_COPY.testimonials.map(function (t, i) { return '<div class="nts-tcard"' + (i >= 3 ? ' hidden' : '') + '><div class="nts-tcard__stars" aria-hidden="true">★★★★★</div><p>' + t.text + '</p><cite>' + t.name + '</cite></div>'; }).join('') + '</div>' +
          '<button type="button" class="nts-btn nts-btn--ghost nts-more" data-more>' + DRAFT_COPY.moreReviews + '</button>';
      },
      // Capítulo de cierre pensado para convertir: oferta con precio (el botón es el de la barra fija), pasos en una línea,
      // una cita y las dudas plegadas (pedido de Nathi, 2026-10-28: menos contenido, sin cuadro verde).
      consult: function () {
        var c = OWNER_COPY.consult;
        var t = OWNER_COPY.testimonials[1];
        return '<h2 tabindex="-1">' + c.title + '</h2>' +
          '<img class="nts-team" src="' + esc(images.team || ASSETS + c.teamImg) + '" alt="' + c.teamAlt + '" loading="lazy">' +
          '<div class="nts-offer">' +
            '<p class="nts-offer__name">' + c.name + '</p>' +
            '<p class="nts-offer__desc">' + c.desc + '</p>' +
            '<div class="nts-facts">' + c.facts.map(function (f) { return '<span>✓ ' + f + '</span>'; }).join('') + '</div>' +
          '</div>' +
          '<p class="nts-how-title">' + OWNER_COPY.howTitle + '</p>' +
          '<ol class="nts-how">' + OWNER_COPY.how.map(function (h) { return '<li>' + h.title + '</li>'; }).join('') + '</ol>' +
          '<div class="nts-quote" style="margin-top:22px">' + t.text + '<cite>' + t.name + '</cite></div>' +
          '<h3 style="margin-top:28px;font-size:22px">' + OWNER_COPY.faqTitle + '</h3>' +
          OWNER_COPY.faq.map(function (f) { return '<details class="nts-faq"><summary>' + f.q + '</summary>' + f.a.map(function (p) { return Array.isArray(p) ? '<ul>' + p.map(function (li) { return '<li>' + li + '</li>'; }).join('') + '</ul>' : '<p>' + p + '</p>'; }).join('') + '</details>'; }).join('') +
          '<p class="nts-small" style="margin-top:18px">' + OWNER_COPY.disclaimer + '</p>' +
          (cfg.debug ? '<details class="nts-debug" data-clarity-mask="True"><summary>' + DRAFT_COPY.debugTitle + '</summary><pre>' + esc(JSON.stringify(R.data, null, 2)) + '</pre></details>' : '');
      }
    };

    function renderChapter() {
      phase = 'journey';
      var ch = CHAPTERS[chapter];
      var last = chapter === CHAPTERS.length - 1;
      furthestChapter = Math.max(furthestChapter, chapter);
      view.innerHTML =
        '<div class="nts-journey">' +
          '<div class="nts-jhead">' +
            '<div class="nts-jhead__segs">' + CHAPTERS.map(function (_, i) { return '<i class="' + (i < chapter ? 'is-done' : i === chapter ? 'is-current' : '') + '"></i>'; }).join('') + '</div>' +
            '<div class="nts-jhead__row"><span class="nts-jhead__label"><b>' + ch.label + '</b> · ' + DRAFT_COPY.chapterOf(chapter + 1, CHAPTERS.length) + '</span>' +
              (last ? '' : '<a class="nts-jhead__book" data-book href="' + esc(bookingUrl) + '" target="_blank" rel="noopener">' + DRAFT_COPY.bookShort + '</a>') +
            '</div>' +
          '</div>' +
          '<div class="nts-chapter">' + CHAPTER_VIEWS[ch.id]() + '</div>' +
          '<div class="nts-jfoot">' +
            '<button type="button" class="nts-btn nts-btn--ghost" data-jback aria-label="Capítulo anterior"' + (chapter === 0 ? ' disabled' : '') + '>←</button>' +
            (last
              ? '<a class="nts-btn nts-btn--lilac nts-jnext" data-book href="' + esc(bookingUrl) + '" target="_blank" rel="noopener">' + OWNER_COPY.consult.cta + '\u00a0→</a>'
              : '<button type="button" class="nts-btn nts-jnext" data-jnext>' + arrow(CHAPTERS[chapter + 1].next) + '</button>') +
          '</div>' +
        '</div>';
      var nx = q('[data-jnext]');
      if (nx) nx.addEventListener('click', function () { goChapter(chapter + 1); });
      q('[data-jback]').addEventListener('click', function () { goChapter(chapter - 1); });
      var more = q('[data-more]');
      if (more) more.addEventListener('click', function () { qa('.nts-tcard[hidden]').forEach(function (c) { c.hidden = false; }); more.remove(); track('test_sintomas_more_reviews', {}); });
      qa('.nts-faq').forEach(function (d, i) { d.addEventListener('toggle', function () { if (d.open) track('test_sintomas_faq_open', { faq_index: i + 1 }); }); });
      qa('[data-book]').forEach(function (a) { a.addEventListener('click', function () { track('test_sintomas_book_click', { chapter: CHAPTERS[chapter].id }); }); });
      growBars();
      track('test_sintomas_result_chapter', { chapter: ch.id, chapter_index: chapter + 1 });
      var h = q('.nts-chapter h2');
      if (h) h.focus({ preventScroll: true });
      if (ch.id === 'reveal') countUp();
    }

    function goChapter(i) {
      if (i < 0 || i >= CHAPTERS.length) return;
      chapter = i;
      renderChapter();
      scrollIntoPlace();
    }

    function countUp() {
      var target = R.s.full;
      var ring = q('.nts-ring');
      var num = q('[data-ring-num]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var start = performance.now();
      var dur = reduce ? 0 : 1300;
      function tick(now) {
        var t = dur ? Math.min(1, (now - start) / dur) : 1;
        var eased = 1 - Math.pow(1 - t, 3);
        num.textContent = Math.round(target * eased);
        ring.style.setProperty('--p', ((target * eased) / 44) * 100);
        if (t < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    // Atajos de teclado solo cuando la usuaria está dentro del test.
    document.addEventListener('keydown', function (e) {
      if (e.metaKey || e.ctrlKey || e.altKey || !document.body.contains(root)) return;
      var active = document.activeElement;
      var inside = root.contains(active) || active === document.body;
      var rect = root.getBoundingClientRect();
      if (!inside || rect.bottom < 0 || rect.top > window.innerHeight) return;
      var tag = active && active.tagName;
      if (phase === 'journey') {
        if (tag === 'INPUT' || tag === 'TEXTAREA') return;
        if (e.key === 'ArrowRight') goChapter(chapter + 1);
        if (e.key === 'ArrowLeft') goChapter(chapter - 1);
        return;
      }
      if (phase !== 'quiz') return;
      if (e.key === 'Enter' && tag !== 'BUTTON' && tag !== 'A' && !(tag === 'TEXTAREA' && e.shiftKey)) { e.preventDefault(); next(); return; }
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      var btn = q('.nts-opt[data-key="' + e.key.toUpperCase() + '"]');
      if (btn) { e.preventDefault(); btn.click(); }
    });

    renderHook();
    watchView();

    // Cuenta una vista cuando se ve un tercio de la pantalla de entrada, una vez por carga.
    function watchView() {
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        track('test_sintomas_view', {});
      }, { threshold: 0.3 });
      io.observe(view);
    }
  }

  function mountAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-nts]'), mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mountAll(); });
  else mountAll();
  // Editor del tema de Shopify: vuelve a montar cuando se edita la sección.
  document.addEventListener('shopify:section:load', function (e) { mountAll(e.target); });
})();
